import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-login-failed',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './login-failed.component.html',
  styleUrl: './login-failed.component.scss'
})
export class LoginFailedComponent {

}
